import { createIcon } from '@chakra-ui/icons';

export const TrackImportedContent = createIcon({
  displayName: 'TrackImportedContent',
  viewBox: '0 0 20 21',
  path: [
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="20" height="20" rx="10" fill="#FADFB2" />

      <path
        d="M10.354 5.64694C10.1591 5.45141 9.84247 5.45096 9.64694 5.64595L6.46052 8.82349C6.26499 9.01848 6.26455 9.33506 6.45954 9.5306C6.65453 9.72613 6.97111 9.72657 7.16664 9.53158L9.99901 6.70711L12.8235 9.53948C13.0185 9.73501 13.3351 9.73545 13.5306 9.54046C13.7261 9.34547 13.7266 9.02889 13.5316 8.83336L10.354 5.64694ZM9.99023 13L10.4902 13.0007L10.5 6.0007L10 6L9.5 5.9993L9.49023 12.9993L9.99023 13Z"
        fill="#AF8236"
      />

      <path d="M5 15L15 15" stroke="#AF8236" />
    </svg>,
  ],
});
